export const CLINIC_LOGO = "/assets/logo.jpeg";

export const CLINIC_FRONT = "/assets/clinic-front.jpg";

export const CLINIC_VIDEO =
    "https://customer-assets.emergentagent.com/job_smile-galaxy-dental/artifacts/gak185in_WhatsApp%20Video%202026-07-02%20at%206.02.35%20AM%20%281%29.mp4";

export const SERVICES = [
    {
        id: "implants",
        title: "Dental Implants",
        icon: "Anchor",
        description:
            "1,000+ implants placed by Dr. Swapnil. Single-tooth, multiple-teeth and full-arch smiles restored to feel exactly like natural.",
    },
    {
        id: "prosthodontics",
        title: "Prosthodontics & Crowns",
        icon: "Crown",
        description:
            "Crowns, bridges, veneers and full-mouth rehabilitations — planned prosthodontically for lasting bite, function and beauty.",
    },
    {
        id: "cosmetic",
        title: "Cosmetic Smile Makeovers",
        icon: "Sparkles",
        description:
            "Complete smile makeovers with porcelain veneers, laminates and digital smile design personalised to your face.",
    },
    {
        id: "rootcanal",
        title: "Painless Root Canal",
        icon: "Waves",
        description:
            "Single-sitting rotary root canal treatment — virtually pain-free with the latest apex locators and endo-motors.",
    },
    {
        id: "whitening",
        title: "Teeth Whitening",
        icon: "Sun",
        description:
            "Chairside whitening that safely lifts your natural shade by several shades in a single 45-minute session.",
    },
    {
        id: "pediatric",
        title: "Pediatric Dentistry",
        icon: "Baby",
        description:
            "Gentle, kid-friendly care from the very first tooth — sealants, fillings and habit-breaking treatments.",
    },
    {
        id: "surgery",
        title: "Oral Surgery",
        icon: "Scissors",
        description:
            "Wisdom teeth removal and minor oral surgery performed with the strictest sterile protocols and modern anaesthesia.",
    },
    {
        id: "digital-xray",
        title: "Digital X-Rays",
        icon: "ScanLine",
        description:
            "In-house digital radiography with up to 90% less radiation — instant, precise diagnosis for every treatment plan.",
    },
];

export const FACILITIES = [
    {
        id: "sedation",
        title: "Conscious Sedation Machine",
        tag: "Anxiety-free dentistry",
        icon: "HeartPulse",
        image: "/assets/sedation.jpeg",
        description:
            "In-house conscious sedation lets nervous patients — including children and dental-phobic adults — undergo long procedures completely relaxed while remaining awake and responsive. A true game-changer for full-mouth work and implant surgery.",
    },
    {
        id: "intraoral-scanner",
        title: "Digital Intraoral Scanner",
        tag: "Zero-goop impressions",
        icon: "ScanFace",
        image: "/assets/intraoral-scanner.jpg",
        description:
            "Say goodbye to gooey impression trays. Our 3D intraoral scanner captures your teeth in seconds — sharper crowns, better-fitting aligners and same-day design previews on screen before we start.",
    },
];

export const DOCTOR = {
    name: "Dr. Swapnil Tamrakar",
    credentials: "BDS, MDS · Prosthodontist & Implant Specialist",
    years: "15+ years",
    implants: "1,000+ implants placed",
    bio: [
        "Dr. Swapnil Tamrakar is a Prosthodontist and Implantologist who has been quietly shaping smiles across Udaipur and Rajasthan for over 15 years. His prosthodontic training brings a rare, engineering-grade precision to every crown, bridge, veneer and implant he places.",
        "With more than 1,000 successful implants and countless full-mouth rehabilitations to his name, Dr. Swapnil is the trusted second opinion for complex cases — known equally for his surgical steadiness and his warm, unhurried chairside manner.",
    ],
    // Real portrait provided by clinic.
    portrait: "/assets/dr-swapnil.jpeg",
};

export const GALLERY = [
    CLINIC_FRONT,
    "https://images.pexels.com/photos/4269361/pexels-photo-4269361.jpeg",
    "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?auto=format&fit=crop&w=1400&q=80",
    "https://images.pexels.com/photos/6529111/pexels-photo-6529111.jpeg",
];

export const CASES = [
    {
        id: "sahil",
        name: "Amit*",
        treatment: "Full Smile Makeover · Veneers & Whitening",
        summary:
            "Heavy staining and worn-down front teeth restored to a bright, uniform smile through ceramic veneers and professional whitening.",
        before: {
            src: "/assets/case-amit-pre.jpg",
            barTop: 28,
            barHeight: 16,
        },
        after: {
            src: "/assets/case-amit-post.jpg",
            barTop: 42,
            barHeight: 18,
        },
    },
    {
        id: "md",
        name: "Meera*",
        treatment: "Cosmetic Correction · Bonding & Alignment",
        summary:
            "Minor crowding and midline gap corrected with conservative cosmetic bonding — no braces, no drilling. Delivered in a single sitting.",
        before: {
            src: "/assets/case-meera-pre.jpg",
            barTop: 30,
            barHeight: 16,
        },
        after: {
            src: "/assets/case-meera-post.jpg",
            barTop: 32,
            barHeight: 16,
        },
    },
];


export const TESTIMONIALS = [
    {
        name: "Aditi Bhatnagar",
        location: "Udaipur",
        quote: "Dr. Swapnil rebuilt my front teeth after a fall — the match is invisible and I honestly forget which ones are the implants. Five-star craftsmanship.",
        rating: 5,
    },
    {
        name: "Rohan Purohit",
        location: "Fatehsagar",
        quote: "Painless root canal in a single sitting, warm hospitality and honest pricing. Easily the most professional dental clinic in Udaipur.",
        rating: 5,
    },
    {
        name: "Meera Choudhary",
        location: "Sukhadia Circle",
        quote: "The conscious sedation option was a lifesaver for my son. He walked out smiling after two hours of treatment with zero anxiety.",
        rating: 5,
    },
    {
        name: "Vikram Rathore",
        location: "Hiran Magri",
        quote: "The digital scanner and full-mouth rehab plan Dr. Swapnil designed for me feel truly world-class. Worth every rupee.",
        rating: 5,
    },
];

export const FAQS = [
    {
        q: "How do I book an appointment at Galaxy Dental Clinic?",
        a: "Simply click the ‘Book Appointment’ button anywhere on this site, fill in your details and pick a slot. Our front desk confirms every booking on WhatsApp within 30 minutes during clinic hours.",
    },
    {
        q: "What is conscious sedation dentistry and is it safe?",
        a: "Conscious sedation is a mild, monitored sedation that keeps you calm, relaxed and pain-free while remaining fully awake and responsive. It is safe, reversible and administered under strict medical protocols — ideal for anxious patients and longer implant / surgical procedures.",
    },
    {
        q: "Do you accept EMI and cashless payments?",
        a: "Yes — treatments can be paid via UPI, credit/debit cards, net banking and easy no-cost EMI plans. Cashless treatments are available for most leading health insurers; share your card at reception and we handle the rest.",
    },
    {
        q: "What are your clinic timings?",
        a: "Monday to Saturday: 10:00 AM – 2:00 PM and 4:00 PM – 8:00 PM. Sunday: 10:00 AM – 2:00 PM only. For emergencies outside these hours, WhatsApp us and we will do our best to accommodate you.",
    },
    {
        q: "How do you handle sterilisation and infection control?",
        a: "We follow OSAP and CDC-grade protocols — Class B autoclaves, single-use kits where applicable, digital tracking of every sterilised instrument, and dedicated infection-control checks for every patient.",
    },
    {
        q: "Do you treat patients from outside Udaipur?",
        a: "Absolutely. We host patients from across Rajasthan, India and abroad. Share your recent X-rays and photos on WhatsApp and Dr. Swapnil will draft a personalised smile plan before your visit.",
    },
];

export const CLINIC = {
    name: "Galaxy Dental Clinic",
    tagline: "Creating Beautiful Smiles",
    location: "Udaipur, Rajasthan",
    address:
        "217, Vivek Nagar, Sector 3, Hiranmagri, Vikas Hospital Link Road, Udaipur, Rajasthan 313001",
    phone: "+91 94622 26238",
    phoneRaw: "+919462226238",
    whatsapp: "919462226238",
    email: "galaxydentaludaipur@gmail.com",
    hours: "Mon – Sat · 10 AM – 2 PM & 4 PM – 8 PM  ·  Sun · 10 AM – 2 PM",
    hoursShort: "Mon–Sat 10–2 & 4–8  ·  Sun 10–2",
    mapsLink: "https://maps.app.goo.gl/KpCB2wfsXTZ1fvyj6",
    mapEmbed:
        "https://www.google.com/maps?q=Galaxy+Dental+Clinic+217+Vivek+Nagar+Sector+3+Hiranmagri+Udaipur&hl=en&z=17&output=embed",
    stats: [
        { value: "15+", label: "Years of Practice" },
        { value: "1,000+", label: "Implants Placed" },
        { value: "4.8★", label: "Google Rating" },
        { value: "530+", label: "Patient Reviews" },
    ],
};

export const HERO_IMAGE =
    "https://images.unsplash.com/photo-1769559893692-c6d0623bf8e4";
